import { pushEvent } from 'src/client/data-layer';

export const trackKeywordSuggestionClicked = (value: string) => {
  pushEvent('keywordSuggestionClicked', {
    value,
  });
};
